import { languages, useI18n } from '../i18n';

export default function LanguageSelect({ label }) {
  const { lang, switchLanguage } = useI18n();

  return (
    <div className="flex items-center gap-2">
      {label && (
        <label htmlFor="language-select" className="sr-only">
          {label}
        </label>
      )}
      <select
        id="language-select"
        value={lang}
        onChange={(e) => switchLanguage(e.target.value)}
        className="rounded-none border-2 border-[#FDE68A] bg-[#FFFBEB] px-3 py-2 pr-8 text-sm font-medium text-[#78350F] focus:border-[#F59E0B] focus:outline-none focus:ring-2 focus:ring-[#F59E0B] cursor-pointer"
      >
        {Object.entries(languages).map(([code, { label: langLabel }]) => (
          <option key={code} value={code}>
            {langLabel}
          </option>
        ))}
      </select>
    </div>
  );
}
